import { render } from "./DocumentViewer.vue?vue&type=template&id=5ceeb842"
import script from "./DocumentViewer.vue?vue&type=script&lang=js"
export * from "./DocumentViewer.vue?vue&type=script&lang=js"

import "./DocumentViewer.vue?vue&type=style&index=0&id=5ceeb842&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__